export default __webpack_public_path__ + "static/media/logo-guardiao-2-v-v2.99f8fe9e.png";